function _extends() {_extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}import React, { useRef, useEffect } from 'react';

export const PointSectionComponent = ({
  children,
  'aria-checked': ariaChecked,
  ...props }) =>
{
  const ref = useRef(null);

  const didMountRef = useRef(false);

  useEffect(() => {
    if (ref.current && ariaChecked && didMountRef.current) {
      ref.current.focus();
    }
  }, [ariaChecked]);

  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
    }
  }, []);

  return /*#__PURE__*/(
    React.createElement("div", _extends({ ref: ref, "aria-checked": ariaChecked }, props),
    children));


};